export * from "./settings.routes";
